export class LineDrawer {
  draw(context, particle, radius) {
    var _shapeData$cap;
    const shapeData = particle.shapeData;
    context.moveTo(-radius / 2, 0);
    context.lineTo(radius / 2, 0);
    context.lineCap = (_shapeData$cap = shapeData === null || shapeData === void 0 ? void 0 : shapeData.cap) !== null && _shapeData$cap !== void 0 ? _shapeData$cap : "butt";
  }
  getSidesCount() {
    return 1;
  }
}